export const ReservedSearchParams = new Set([
    "search",  // search term
    "page",    // pagination
    "cursor",  // cursor pagination (if you add it later)
    "sort",    // optional
    "limit",   // optional
    "loaded",
    "restore",
    "from"  // legacy breadcrumb-context flag, no longer set; kept reserved so any
            // lingering ?from=all link is ignored rather than treated as a filter
]);